import { render, staticRenderFns } from "./empresasAsociadas.vue?vue&type=template&id=8ec2ed3a&scoped=true"
import script from "./empresasAsociadas.vue?vue&type=script&lang=js"
export * from "./empresasAsociadas.vue?vue&type=script&lang=js"
import style0 from "./empresasAsociadas.vue?vue&type=style&index=0&id=8ec2ed3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec2ed3a",
  null
  
)

export default component.exports